module.exports = __webpack_public_path__ + "img/sky-porch-1.1a5d56b1.jpg";